import { RootState } from "../../rootReducer";

export const selectIsLoadingHighStress = (state: RootState) =>
  state.sendHighStressNotification.loading;
export const selectIsSavedHighStress = (state: RootState) =>
  state.sendHighStressNotification.saved;
export const selectHighStressErrorMessage = (state: RootState) =>
  state.sendHighStressNotification.error;
export const sendHighStressNotificationDataResponse = (state: RootState) =>
  state.sendHighStressNotification.sendHighStressNotificationResponse;
